<template>
  <section class="page-panel">
    <header class="page-panel__header"><h3 class="panel-title">Podaci o korisniku</h3></header>
    <div class="page-panel__content grid grid-column-gap-16 grid-row-gap-18">
      <div v-for="field in fields" :key="field.key" :class="field.wide ? 'col-12' : 'col-12 col-sm-6'">
        <RecordReadOnlyField
          v-if="readonly"
          :label="field.label"
          :value="field.date && values[field.key] ? formatDate(values[field.key]) : values[field.key]"
        />
        <AppDateField
          v-else-if="field.date"
          :model-value="values[field.key]"
          :label="field.label"
          :placeholder="field.placeholder"
          @update:model-value="$emit('change', field.key, $event)"
        />
        <AppTextField
          v-else
          :model-value="values[field.key]"
          :label="field.label"
          :placeholder="field.placeholder"
          :type="field.email ? 'email' : 'text'"
          :rules="field.email ? emailRules : [(value) => String(value ?? '').length <= field.max || `Najviše ${field.max} znakova`]"
          @update:model-value="$emit('change', field.key, $event)"
        />
        <p
          v-if="field.key === 'driverLicenseValidUntil' && values.driverLicenseValidUntil && values.pickupDate && values.driverLicenseValidUntil < values.pickupDate"
          class="notice"
          role="alert"
        >
          Vozačka dozvola istječe prije datuma preuzimanja vozila.
        </p>
      </div>
    </div>
  </section>
</template>

<script setup>
import { formatDate } from '../../helpers'
import AppDateField from '../AppDateField.vue'
import AppTextField from '../AppTextField.vue'
import RecordReadOnlyField from './RecordReadOnlyField.vue'

defineProps({
  values: { type: Object, required: true },
  readonly: { type: Boolean, default: false },
})

defineEmits(['change'])

const fields = [
  { key: 'company', label: 'Tvrtka', placeholder: 'Naziv tvrtke', max: 255 },
  { key: 'companyAddress', label: 'Adresa tvrtke', placeholder: 'Ulica i broj, grad', max: 255 },
  { key: 'fullName', label: 'Ime i prezime', placeholder: 'Unesite ime i prezime', max: 255 },
  { key: 'address', label: 'Adresa korisnika', placeholder: 'Ulica i broj, grad', max: 255 },
  { key: 'email', label: 'E-mail', placeholder: 'ime@gmail.com', max: 255, wide: true, email: true },
  { key: 'phone', label: 'Telefon', placeholder: '+385 ...', max: 50, wide: true },
  { key: 'driverLicenseNumber', label: 'Broj vozačke dozvole', placeholder: '00000000', max: 50 },
  { key: 'driverLicenseCategory', label: 'Kat.', placeholder: 'npr. B', max: 20 },
  { key: 'driverLicenseIssuedBy', label: 'Izdana od PU', placeholder: 'Policijska uprava', max: 100 },
  { key: 'driverLicenseValidUntil', label: 'Vrijedi do', placeholder: 'Unesite datum', date: true },
]

const emailRules = [
  (value) => !value || /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value) || 'Unesite ispravnu e-mail adresu',
  (value) => String(value ?? '').length <= 255 || 'Najviše 255 znakova',
]
</script>
